import Vue from 'vue'
import detectHoverTouch from 'library/plugins/detect-hover-touch'
import viewportSizes from 'library/plugins/viewport-sizes'
import readingTime from 'library/plugins/reading-time.js'
import shadowContainer from 'library/plugins/shadow-container.js'
import Swiper from 'library/components/Swiper/component/index.vue'

Vue.use(detectHoverTouch)
Vue.use(viewportSizes)
Vue.use(readingTime)
Vue.use(shadowContainer)
Vue.component('Swiper', Swiper)
